import React from "react";
import Select from "react-select";
import "./DropdownSelect.scss";

function DropdownSelect(props) {
  return (
    <span className="d-inline-block custom-input">
      <Select
        className={`custom-checkbox-select  ${props.validationClass}`}
        value={props.value}
        onChange={props.handleDropdownChange}
        onBlur={props.handleDropdownBlur}
        options={props.optionsValue}
        isMulti={props.isMultiSelect}
        placeholder={props.placeholder}
        isDisabled={props.isDropdownDisabled}
        classNamePrefix="react-select"
        isSearchable={props.isSearchable}
        menuPortalTarget={document.body}
        menuPosition="absolute"
        menuPlacement="auto"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    </span>
  );
}

export default DropdownSelect;
